export default {
  state: {
    userinfo: null,
  },
  mutations: {
    setUser(state: any, userinfo: any) {
      state.userinfo = userinfo;
    },
  },
};
